import * as types from '../actions/types';
export const initialState = {
    transactionsReceipts: {},
};
export const getReceiptTransactionId = (transactionId, isGroup) => isGroup ? `group_transaction_${transactionId}` : transactionId.toString();
const unpersistedTransactions = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_RECEIPTS_SUCCESS: {
            const { payload, extra: { isGroup, transactionId }, } = action;
            const id = getReceiptTransactionId(transactionId, isGroup);
            const transactionsReceipts = {
                ...state.transactionsReceipts,
                [id]: payload.map((r) => {
                    const cachedReceipt = state.transactionsReceipts[id]?.find((receipt) => receipt.id === r.id);
                    const url = r.url?.split('?')[0];
                    const extension = url.split('.').pop();
                    return {
                        ...cachedReceipt,
                        ...r,
                        url: r.url?.split('?')[0],
                        originalUrl: r.url,
                        fileName: r.fileName || `receipt-${r.id}.${extension}`,
                    };
                }),
            };
            return { ...state, transactionsReceipts };
        }
        case types.UPLOAD_RECEIPT_REQUEST: {
            const { transactionId, files, isGroup } = action.extra;
            const now = Date.now();
            const id = getReceiptTransactionId(transactionId, isGroup);
            const newReceipts = files.map(({ name, uri }, i) => ({
                id: now + i,
                fileUri: uri,
                fileName: name,
                isUploading: true,
            }));
            return {
                ...state,
                transactionsReceipts: {
                    ...state.transactionsReceipts,
                    [id]: (state.transactionsReceipts[id] ?? []).concat(newReceipts),
                },
            };
        }
        case types.UPLOAD_RECEIPT_SUCCESS: {
            const { transactionId, files, isGroup } = action.extra;
            if (!action.payload)
                return state;
            const id = getReceiptTransactionId(transactionId, isGroup);
            const targetReceipts = state.transactionsReceipts[id] ?? [];
            const transactionsReceipts = {
                ...state.transactionsReceipts,
                [id]: [
                    ...targetReceipts.slice(0, -files.length),
                    ...action.payload.map((r, i) => ({
                        ...targetReceipts[targetReceipts.length - files.length + i],
                        ...r,
                        url: r.url?.split('?')[0],
                        originalUrl: r.url,
                        isUploading: false,
                    })),
                ],
            };
            return { ...state, transactionsReceipts };
        }
        case types.UPLOAD_RECEIPT_FAILURE: {
            const { transactionId, files, isGroup } = action.extra;
            const id = getReceiptTransactionId(transactionId, isGroup);
            const targetReceipts = state.transactionsReceipts[id];
            if (!targetReceipts)
                return state;
            return {
                ...state,
                transactionsReceipts: {
                    ...state.transactionsReceipts,
                    [id]: state.transactionsReceipts[id].slice(0, -files.length),
                },
            };
        }
        case types.DELETE_RECEIPT_REQUEST: {
            const { receipt, transactionId, isGroup } = action.extra;
            const id = getReceiptTransactionId(transactionId, isGroup);
            if (state.transactionsReceipts[id]) {
                return {
                    ...state,
                    transactionsReceipts: {
                        ...state.transactionsReceipts,
                        [id]: state.transactionsReceipts[id].filter((r) => r.id !== receipt.id),
                    },
                };
            }
            return state;
        }
        case types.DELETE_RECEIPT_FAILURE: {
            const { receipt, transactionId, index, isGroup } = action.extra;
            const id = getReceiptTransactionId(transactionId, isGroup);
            if (state.transactionsReceipts[id]) {
                return {
                    ...state,
                    transactionsReceipts: {
                        ...state.transactionsReceipts,
                        [id]: [
                            ...state.transactionsReceipts[id].slice(0, index),
                            receipt,
                            ...state.transactionsReceipts[id].slice(index),
                        ],
                    },
                };
            }
            return state;
        }
        default:
            return state;
    }
};
export default unpersistedTransactions;
